import React from 'react'

function DashboardEventsSection() {
  return <>
  <div>Bu Sayfa Private EventsSection sayfasıdır</div>
  </>
}

export default DashboardEventsSection